module.exports = __webpack_public_path__ + "static/media/more_pressed.aca20c73.svg";